<ng-container *appFeatureToggle="'desktop'">
    <img src="../../../assets/images/cross.svg" style="width: 24px; float: right; cursor: pointer" (click)="close()" />
    <div style="clear: both"></div>
    <div class="schedule-later">Schedule For Later</div>

    <div style="padding: 20px 15px 10px 15px">
        <mat-form-field [floatLabel]="true" appearance="outline" class="form-field-theme full-width">
            <mat-label>DELIVER LATER</mat-label>
            <mat-select [(value)]="preorderTime" [(ngModel)]="preorderTime" class="preorder-select">
                @for (time of preorderTimeRange; track time) {
                    <mat-option [value]="time" (click)="selectedTimeRange(time)">
                        {{ time - preorderInterval | date: 'hh:mm' }} to {{ time | date: 'hh:mm a' }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div style="padding-bottom: 15px; text-align: center">
        <button btn-primary (click)="updatePreorderTime()">SCHEDULE</button>
    </div>
</ng-container>

<ng-container *appFeatureToggle="'mobile'">
    <div class="mobile-nav-header" mat-dialog-title>
        <button id="backbutton" (click)="close()">
            <mat-icon aria-hidden="true" style="color: var(--dark-grey-text-color)">arrow_back</mat-icon>
        </button>

        <div class="mobile-header-text">
            <span class="navbar-brand-text">DELIVERY SLOTS</span>
        </div>
    </div>
    <div mat-dialog-content>
        <mat-radio-group [value]="selectedTime">
            @if (!isPrimaryBrandPreorderOnly) {
                <div>
                    <div class="deliver-now">DELIVER NOW</div>
                    <mat-radio-button color="primary" [value]="undefined" (click)="selectedTimeRange()">
                        <div class="delivery-time">DELIVERS IN {{ cartEta }} MINUTES</div>
                    </mat-radio-button>
                </div>
            }

            <div>
                <div class="deliver-now">SCHEDULE FOR LATER</div>
                @for (time of preorderTimeRange; track time) {
                    <mat-radio-button
                        class="separtor"
                        color="primary"
                        [value]="time"
                        (click)="outlet.active && outlet.preorder_available && !isPickupSelected && selectedTimeRange(time)"
                        [disabled]="!(outlet.active && outlet.preorder_available && !isPickupSelected)">
                        <div class="delivery-time">
                            <div>{{ time - preorderInterval | date: 'hh:mm a' }} - {{ time | date: 'hh:mm a' }}</div>
                        </div>
                    </mat-radio-button>
                }
            </div>
        </mat-radio-group>
    </div>
    <div class="sticky-bottom">
        <div>
            <button btn-primary size="full" (click)="updatePreorderTime()">Proceed to Checkout</button>
        </div>
    </div>
</ng-container>
